module.exports = __webpack_public_path__ + "media/dogs/schnauzer-opening-box-910f096c.svg";